import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './login/auth.service';

@Injectable({
  providedIn: 'root'
})
export class JwtGuard implements CanActivate {
  isAuth = false;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  // @todo improve

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.hasAuthCookies()) {
      return true;
    } else {
      this.router.navigateByUrl('/login');
      return false;
    }
  }
}
